import DepsService from 'services/dependencies';

const CONTEXT = 'sftp';

export const fetchSftpList = async (params) => {
  const url = DepsService.rest.sftp.admin.configuration.url;
  const queryParams = { ...params };
  const urlParams = {};

  const response = await DepsService.restSrv.get(CONTEXT, url, queryParams, urlParams);

  return response;
};

export const deleteSftpById = async (id) => {
  const url = DepsService.rest.sftp.admin.retailer.configuration.url;
  const requestPayload = { configId: id };

  return await DepsService.restSrv.remove(CONTEXT, url, requestPayload);
};

export const fetchSftpById = async (id) => {
  const url = DepsService.rest.sftp.admin.retailer.configuration.url;
  const queryParams = {};
  const urlParams = { configId: id };

  const sftp = await DepsService.restSrv.list(CONTEXT, url, queryParams, urlParams);

  return sftp;
};

export const updateSftpById = async ({ id, ...sftp }) => {
  const url = DepsService.rest.sftp.admin.retailer.configuration.url;
  const urlParams = { configId: id };
  const requestPayload = { id, ...sftp };

  return await DepsService.restSrv.update(CONTEXT, url, requestPayload, urlParams);
};

export const createSftp = async (sftp) => {
  const url = DepsService.rest.sftp.admin.configuration.url;
  const requestPayload = { ...sftp.configuration };

  return await DepsService.restSrv.create(CONTEXT, url, requestPayload);
};



// WEBPACK FOOTER //
// ./src/modules/report-subscriptions/resources/sftp.api.js